import React, { useState } from "react";

import PerfectScrollbar from "react-perfect-scrollbar";

import useSidebar from "@hooks/useSidebar";
import SidebarNav from "./SidebarNav";

import Logo from "@images/fonda-logo.png";
import { Col, Row } from "react-bootstrap";

const Sidebar = ({ items, showFooter = true }) => {
    const { isOpen } = useSidebar();
    const [width] = useState(window.innerWidth);
    let isMobile = width < 768;

    return (
        <nav className={`sidebar ${!isOpen ? "collapsed" : ""}`}>
            <div className="sidebar-content">
                <PerfectScrollbar>
                    <a className="sidebar-brand pb-2" href="/">
                        <Row>
                            <Col md={3}>
                                <img
                                    src={Logo}
                                    alt="Moe Logo"
                                    style={{
                                        maxWidth: isMobile ? "75px" : "55px",
                                    }}
                                />
                            </Col>
                            <Col md={9}>
                                <p
                                    style={{ fontSize: "15px" }}
                                    className="mb-0 mt-1"
                                >
                                    Fonda Global Engineering Pte. Ltd.
                                </p>
                            </Col>
                        </Row>
                    </a>
                    <SidebarNav items={items} />
                </PerfectScrollbar>
            </div>
        </nav>
    );
};

export default Sidebar;
